export const experiencesEn = [
    {
        title: "Senior Software Engineer",
        company: 'Techlogix Pakistan Pvt. Ltd.',
        period: "Mar 2023 - Present",
        technologies: '.Net 6, C#, .Net Web APIs, Entity Framework, Angular 13, SQL Server, Azure Cloud, Cosmos DB',
        missions: [
            "Working as a Full Stack Developer, creating and modifying multiple features of Patient EHR System.",
            "Performance Optimizations, Deployments, and Customer Support.",
            "Team Collaboration and Training new Members.",
            "Scrum Model (Agile Development).",          
        ],
        detailIsDisplayed: false,
    },
    {
        title: "Software Engineer",
        company: 'Techlogix Pakistan Pvt. Ltd.',
        period: "Aug 2019 - Mar 2023",
        technologies: '.Net 4.8, C#, .Net Web APIs, Entity Framework, angularJs, SQL Server, Azure Cloud, Cosmos',
        missions: [
            "As a Full Stack Developer, working on Hospital Inventory Management System and its integration with Vicenna HealthCloud.",
            "Maintenance and support.",
        ],
        detailIsDisplayed: false,
    },
    {
        title: "Software Engineer",
        company: 'InnovicSoft',
        period: "Mar 2019 - Aug 2019",
        technologies: 'Angular 2, Typescript, Javascript, HTML, CSS, Angular Material Design',
        missions: [
            "User interface design and modifications.",
            "Client Dealing and Requirements.",
        ],
        detailIsDisplayed: false,
    },
    {
        title: "Junior Software Engineer",
        company: 'InnovicSoft',
        period: "Jan 2019 - Mar 2019",
        technologies: 'Angular 2, Typescript, Javascript, HTML, CSS, Angular Material Design',
        missions: [
            "User interface design and modifications.",
            "Client Dealing and Requirements.",
        ],
        detailIsDisplayed: false,
    },
];

